export default {
  PaymentTypeID: {
    CreditNote: {
      ID: 8,
      Label: "Nota Kredit"
    }
  }
}